import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const ToursPageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const TourNameLink = styled(Link)(({ theme }) => ({
  color: theme.palette.info.main,
  textDecoration: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  '&:hover': {
    textDecoration: 'none',
  },
}));
